export const SET_MOSTRAR_BOTON_VOLVER = "SET_MOSTRAR_BOTON_VOLVER";
export const SET_TEXTO_CABECERA = "SET_TEXTO_CABECERA";
export const RESET_PARAMETROS_PSD2 = "RESET_PARAMETROS_PSD2";
export const SET_PARAMETRO_PSD2 = "SET_PARAMETRO_PSD2";
export const REMOVE_PARAMETRO_PSD2 = "REMOVE_PARAMETRO_PSD2";
export const SET_SWITCH = "SET_SWITCH";
export const START_SCROLL = "START_SCROLL";
